function sliderTabs() {

    const tabs = $('._js-tabs-slider');
    let initialSlide = window.currentPage || 0;

    if ( tabs.length ) {
        tabs
            .slick({
                rows            : 0,
                draggable       : false,
                variableWidth   : true,
                slidesToScroll  : 1,
                arrows          : false,
                dots            : false,
                infinite        : false,
                initialSlide    : initialSlide
            })
            .on('click', '.slick-slide', function(){
                $('.slick-slide').removeClass('_current');
                $(this).addClass('_current');
            });
    }


}